import { FC } from 'react';

import Box, { BoxProps } from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface Props {
  height?: BoxProps['height'];
  text?: string;
}

export const Loader: FC<Props> = ({ height = 150, text }) => {
  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      gap={2}
      height={height}
      justifyContent="center"
    >
      <CircularProgress />
      {!!text && <Typography variant="body1">{text}</Typography>}
    </Box>
  );
};
